export default function CTASection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20modern%20logistics%20warehouse%20interior%20with%20neatly%20organized%20shelving%20units%20and%20cardboard%20boxes%20soft%20natural%20overhead%20lighting%20creating%20gentle%20highlights%20clean%20organized%20space%20warm%20beige%20and%20sandy%20tones%20editorial%20product%20photography%20peaceful%20professional%20atmosphere%20no%20people&width=1800&height=1200&seq=yoybuy-cta-v2-01&orientation=landscape"
        alt="Yoybuy Spreadsheet доставка"
        title="Начните заказывать через Yoybuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white uppercase tracking-wide leading-[1.2] mb-6 max-w-[800px]"
          style={{ fontFamily: 'var(--font-heading)' }}>
          Начните покупать через<br />Yoybuy Spreadsheet
        </h2>
        <p className="text-base md:text-lg text-white/70 font-light mb-10 max-w-[600px] leading-relaxed">
          Быстрые заказы через таблицу.<br />Доставка из Китая в любую страну.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-white font-label text-sm font-medium hover:bg-foreground-800 transition-all duration-300 cursor-pointer"
        >
          <div className="w-7 h-7 rounded-full bg-[#E67E22] flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </div>
          <span>Открыть таблицу</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-white/70 text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
          </div>
        </a>
      </div>
    </section>
  );
}